import { useEffect, useState } from "react";

import { TodoService } from "services";

const ACTIVE_TODO_PARAMS: TodoService.TodoListParams = {
  myTodo: true,
  archive: false,
  dateFilter: "NEXT_7_DAYS",
};

interface DashboardTodoStats {
  totalCount: number;
  urgentCount: number;
  importantCount: number;
}

const INITIAL_STATS: DashboardTodoStats = {
  totalCount: 0,
  urgentCount: 0,
  importantCount: 0,
};

const useDashboardTodoStats = () => {
  const [stats, setStats] = useState<DashboardTodoStats>(INITIAL_STATS);

  useEffect(() => {
    let cancelled = false;

    const loadStats = async () => {
      const [totalCount, urgentCount, importantCount] = await Promise.all([
        TodoService.todoNumberValue(ACTIVE_TODO_PARAMS),
        TodoService.todoNumberValue({ ...ACTIVE_TODO_PARAMS, urgent: true }),
        TodoService.todoNumberValue({ ...ACTIVE_TODO_PARAMS, important: true }),
      ]);

      if (cancelled) {
        return;
      }

      setStats({
        totalCount,
        urgentCount,
        importantCount,
      });
    };

    loadStats();

    return () => {
      cancelled = true;
    };
  }, []);

  return stats;
};

export default useDashboardTodoStats;
